import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Chart } from 'chart.js';

import { AppModule } from './app/app.module';

// The report charts draw on a canvas the stylesheets cannot reach; the size is set once, before
// any component registers a chart — per SPEC-2026-10-platform-font-legibility RF-09.
Chart.defaults.font.size = 13;

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
